// removed by extract-text-webpack-plugin
module.exports = {"new-input":"sDIRS4b05 vUrsJl1Yt","address-input":"tVJ2Pk_SQ _1pOLDbgQd","cancel":"_2M5TztYI7 Xua7s1qyX _1sJfY6k2x"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/venue-search/venue-search-google/venue-search-google.css
 ** module id = 2169
 ** module chunks = 0
 **/